import { render, staticRenderFns } from "./ds-table.vue?vue&type=template&id=99185da8&scoped=true"
import script from "./ds-table.vue?vue&type=script&lang=ts"
export * from "./ds-table.vue?vue&type=script&lang=ts"
import style0 from "./ds-table.vue?vue&type=style&index=0&id=99185da8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99185da8",
  null
  
)

export default component.exports